var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.337 17.802a2.404 2.404 0 0 1-2.674 0l-6.556-4.371A2.346 2.346 0 0 1 8 13.356v7.162c0 .821.666 1.473 1.473 1.473h13.054c.821 0 1.473-.667 1.473-1.473v-7.163a2.41 2.41 0 0 1-.107.076l-6.556 4.371z",
    fill: "#7CB6E1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m8.627 12.651 6.556 4.371a1.471 1.471 0 0 0 1.634 0l6.556-4.37c.393-.262.627-.7.627-1.172 0-.812-.66-1.472-1.472-1.472H9.472c-.811 0-1.472.66-1.472 1.473 0 .471.234.909.627 1.17z",
    fill: "#7CB6E1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailWhite);
export default __webpack_public_path__ + "static/media/emailWhite.d2b83973e0b84bac9270b0d778202f26.svg";
export { ForwardRef as ReactComponent };